export const NAV_LAYOUT_LS_KEY = 'sschool.navigation.layout'
export const NAV_LAYOUT_EVENT = 'sschool:navigation-layout-change'

export const NAV_LAYOUT_FLAT = 'flat'
export const NAV_LAYOUT_GROUPED = 'grouped'

export const readNavigationLayout = () => {
  try {
    const v = localStorage.getItem(NAV_LAYOUT_LS_KEY)
    return v === NAV_LAYOUT_GROUPED ? NAV_LAYOUT_GROUPED : NAV_LAYOUT_FLAT
  } catch {
    return NAV_LAYOUT_FLAT
  }
}

export const writeNavigationLayout = mode => {
  try {
    localStorage.setItem(
      NAV_LAYOUT_LS_KEY,
      mode === NAV_LAYOUT_GROUPED ? NAV_LAYOUT_GROUPED : NAV_LAYOUT_FLAT
    )
    window.dispatchEvent(new Event(NAV_LAYOUT_EVENT))
  } catch {
    // ignore
  }
}
